import { Box, Grid } from '@mui/material';
import {
  Control,
  Controller,
  FieldErrors,
  UseFormRegister,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  LegacyAutocomplete,
  LegacyMuiTextField,
} from '~/legacy-components/LegacyForms';

import { Country, EmpOtherContactType } from '../../data';
import { IFormInput } from '../../useOtherContact';

import { useSxStyles } from './useStyles';

type Props = {
  data: EmpOtherContactType;
  register: UseFormRegister<IFormInput>;
  errors: FieldErrors<IFormInput>;
  countryList: Country[];
  control: Control<IFormInput>;
};

export const OtherContactEditMode = ({
  register,
  errors,
  countryList,
  control,
  data: emp,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  return (
    <div>
      <Box component="table" sx={sxStyles.tableEdit}>
        <tbody>
          <tr>
            <td>
              <Box
                component="label"
                htmlFor="fEmpPhoneOther"
                sx={sxStyles.label}
              >
                {t('fEmpPhoneHome')}:
              </Box>
            </td>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              <Box
                component="input"
                {...register('fEmpPhoneOther')}
                type="text"
                sx={errors.fEmpPhoneOther ? sxStyles.errorMsg : sxStyles.input}
                defaultValue={emp?.fEmpPhoneOther}
              />
            </Box>
          </tr>

          <tr>
            <td>
              {errors.fEmpPhoneOther && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpPhoneOther.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>

          <tr>
            <td>
              <Box
                component="label"
                htmlFor="fEmpEmailOther"
                sx={sxStyles.label}
              >
                {t('fEmpEmailHome')}:
              </Box>
            </td>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              <Box
                component="input"
                {...register('fEmpEmailOther')}
                type="text"
                sx={errors.fEmpEmailOther ? sxStyles.errorMsg : sxStyles.input}
                defaultValue={emp?.fEmpEmailOther}
              />
            </Box>
          </tr>
          <tr>
            <td>
              {errors.fEmpEmailOther && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpEmailOther.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <Box
                component="label"
                htmlFor="fEmpStreetAddress1"
                sx={sxStyles.label}
              >
                {t('fEmpStreetAddress1')}:{' '}
                <Box component="i" sx={sxStyles.required}></Box>
              </Box>
            </td>
          </tr>

          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              <Box
                component="input"
                {...register('fEmpStreetAddress1')}
                type="text"
                sx={
                  errors.fEmpStreetAddress1 ? sxStyles.errorMsg : sxStyles.input
                }
                defaultValue={emp?.fEmpStreetAddress1}
              />
            </Box>
          </tr>
          <tr>
            <td>
              {errors.fEmpStreetAddress1 && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpStreetAddress1.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <Box
                component="label"
                htmlFor="fEmpStreetAddress2"
                sx={sxStyles.label}
              >
                {t('fEmpStreetAddress2')}:
              </Box>
            </td>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              <Box
                component="input"
                {...register('fEmpStreetAddress2')}
                type="text"
                sx={
                  errors.fEmpStreetAddress2 ? sxStyles.errorMsg : sxStyles.input
                }
                defaultValue={emp?.fEmpStreetAddress2}
              />
            </Box>
          </tr>
          <tr>
            <td>
              {errors.fEmpStreetAddress2 && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpStreetAddress2.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <Box
                component="label"
                htmlFor="fEmpPostalCode"
                sx={sxStyles.label}
              >
                {t('fEmpPostalCode')}:{' '}
                <Box component="i" sx={sxStyles.required}></Box>
              </Box>
            </td>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              <Box
                component="input"
                {...register('fEmpPostalCode')}
                type="text"
                sx={errors.fEmpPostalCode ? sxStyles.errorMsg : sxStyles.input}
                defaultValue={emp?.fEmpPostalCode}
              />
            </Box>
          </tr>
          <tr>
            <td>
              {errors.fEmpPostalCode && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpPostalCode.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <Box component="label" htmlFor="fEmpState" sx={sxStyles.label}>
                {t('fEmpState')}:
              </Box>
            </td>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              <Box
                component="input"
                {...register('fEmpState')}
                type="text"
                sx={errors.fEmpState ? sxStyles.errorMsg : sxStyles.input}
                defaultValue={emp?.fEmpState}
              />
            </Box>
          </tr>
          <tr>
            <td>
              {errors.fEmpState && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpState.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <Box component="label" htmlFor="fEmpCity" sx={sxStyles.label}>
                {t('fEmpCity')}:{' '}
                <Box component="i" sx={sxStyles.required}></Box>
              </Box>
            </td>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              <Box
                component="input"
                {...register('fEmpCity')}
                type="text"
                sx={errors.fEmpCity ? sxStyles.errorMsg : sxStyles.input}
                defaultValue={emp?.fEmpCity}
              />
            </Box>
          </tr>
          <tr>
            <td>
              {errors.fEmpCity && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpCity.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <Box component="label" htmlFor="fEmpCountry" sx={sxStyles.label}>
                {t('fEmpCountry')}:{' '}
                <Box component="i" sx={sxStyles.required}></Box>
              </Box>
            </td>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              {
                <Controller
                  control={control}
                  name="fEmpCountry"
                  defaultValue={emp?.fEmpCountry}
                  render={({ field: { onChange, value } }) => (
                    <LegacyAutocomplete
                      fullWidth
                      sx={errors.fEmpCountry && sxStyles.errorMsgSelect}
                      options={countryList}
                      getOptionLabel={(c) => c.name}
                      onChange={(e, value) => {
                        onChange(value?.code || '');
                      }}
                      value={
                        countryList.find((op) => op.code === value) || null
                      }
                      renderInput={(params) => (
                        <LegacyMuiTextField {...params} placeholder={' '} />
                      )}
                    />
                  )}
                />
              }
            </Box>
          </tr>
          <tr>
            <td>
              {errors.fEmpCountry && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpCountry.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>
        </tbody>
      </Box>
    </div>
  );
};
